const Pasl = {
  symbol: 'pasl',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm-.92-11.844l-2.796 1.16.153-.839 2.097-.87a.515.515 0 0 0 .277-.671.51.51 0 0 0-.667-.28l-1.487.618.283-1.556h5.275c4.583 0 7.285-2.858 7.285-6.553 0-2.913-2.073-4.298-6.22-4.155h-6.773l-2.398 13.321-3.293 1.367a.515.515 0 0 0-.277.671.51.51 0 0 0 .667.28l2.687-1.116-.15.839-1.99.825a.515.515 0 0 0-.277.671.51.51 0 0 0 .668.28l1.382-.574L9.269 25h2.344l.452-2.48 3.406-1.414a.515.515 0 0 0 .277-.671.51.51 0 0 0-.667-.28zm-.57-11.047h5.154c2.556 0 3.323 1.07 3.323 2.656 0 1.584-1.22 3.769-4.43 3.769h-5.219z" fill-rule="evenodd"/>`;
  },
  colorIcon() {
    return `<g fill="none" fill-rule="evenodd"><circle cx="16" cy="16" fill="#00acff" r="16"/><path d="M15.08 20.156a.51.51 0 0 1 .668.279.515.515 0 0 1-.277.671l-3.406 1.414-.452 2.48H9.269l.257-1.426-1.382.573a.51.51 0 0 1-.668-.279.515.515 0 0 1 .277-.67l1.99-.826.15-.839-2.687 1.115a.51.51 0 0 1-.667-.279.515.515 0 0 1 .277-.671l3.293-1.367L12.507 7.01h6.773c4.147-.143 6.22 1.242 6.22 4.155 0 3.695-2.702 6.553-7.285 6.553H12.94l-.283 1.556 1.487-.617a.51.51 0 0 1 .667.279.515.515 0 0 1-.277.67l-2.097.871-.153.84zm-.57-11.047l-1.172 6.425h5.218c3.212 0 4.43-2.185 4.43-3.77 0-1.584-.766-2.655-3.322-2.655z" fill="#fff"/></g>`;
  }
};
export default Pasl;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-cryptoicon/src/icons/pasl.js
// module id = null
// module chunks = 